import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { addDays } from 'date-fns';
import { Paper, Grid, Collapse, IconButton, Typography } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import i18n from '../../i18n';
import DateHeadings from '../Schedule/DateHeadings';
import AvailabilityEmployeeChip from './AvailabilityEmployeeChip';
import { UNAVAILABLE_AD } from '../../constants/general';

class AvailabilityPositionSchedule extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expandView: true
    };
  }

  displaySchedule = () => {
    const { expandView } = this.state;
    const {
      includeWeekend,
      numberOfRequestedWeeks,
      positionName,
      scheduleData,
      startOfSelectedWeek
    } = this.props;
    if (!scheduleData || !scheduleData.length) {
      return i18n.t('availability:noEmployeesForThisPosition');
    }
    if(!this.filterAvailable(scheduleData).length){
      return i18n.t('availability:noEmployeesAvailableForThisPosition')
    }
    const orderedScheduleData = _.orderBy(
      scheduleData,
      ['bookingPriority', 'name'], ['asc', 'asc']
    );
    const weeklySegments = [];
    const weekOffset = includeWeekend ? 7 : 5;
    for (let i = 0; i < numberOfRequestedWeeks; i++) {
      const currentStartOfWeek = addDays(startOfSelectedWeek, 7 * i);
      const sliceStart = i * 7;
      const sliceEnd = sliceStart + weekOffset;
      const filteredAvailabilities = this.filterAvailable(orderedScheduleData, sliceStart, sliceEnd);
      weeklySegments.push(
        <DateHeadings
          key={`${positionName}-${currentStartOfWeek}-${i}`}
          startOfSelectedWeek={currentStartOfWeek}
          includeWeekend={includeWeekend}
        />,
        filteredAvailabilities.length === 0 ? (
          <Typography className='availabilityWarning'>
            { i18n.t('availability:noEmployeesAvailableForThisPosition') }
          </Typography>
        ) : filteredAvailabilities.map(employee => {
          return (
            <Grid container key={`${positionName}-${currentStartOfWeek}-${i}-${employee.name}`}>
              <Grid
                item
                xs={2}
                className='locationLabel'
              >
                {`Priority: ${employee.bookingPriority}`}
              </Grid>
              {employee.availabilitySchedule.slice(sliceStart, sliceEnd).map(availability => (
                <Grid
                  item
                  xs={includeWeekend ? 1 : 2}
                  className={
                    includeWeekend ? 'customGridItem includeWeekend' : ''
                  }
                  key={`${positionName}-${availability.date}-${employee.name}`}
                >
                  <AvailabilityEmployeeChip
                    employee={employee}
                    availability={availability}
                  />
                </Grid>
              ))}
              <Grid item xs={12}>
                <hr />
              </Grid>
            </Grid>
          );
        }),
      );
    }
    return (
      <Collapse in={expandView} timeout='auto'>
        <Grid container>
          {weeklySegments}
        </Grid>
      </Collapse>
    )
  }

  filterAvailable = (orderedScheduleData, sliceStart = null, sliceEnd = null) => {
    const {
      hideUnavailables
    } = this.props;

    if(!hideUnavailables){
      return orderedScheduleData;
    }

    return orderedScheduleData.filter(employee => {
      const availabilitySchedule = sliceStart === null ? 
        employee.availabilitySchedule : 
        employee.availabilitySchedule.slice(sliceStart, sliceEnd)
      return availabilitySchedule.find((availability)=>{
        return availability.status !== UNAVAILABLE_AD
      });
    });
  };

  handleExpandClick = () => {
    this.setState(prevState => ({ expandView: !prevState.expandView }));
  };

  render() {
    const {
      expandView
    } = this.state;

    const {
      positionName
    } = this.props;
    return (
      <Paper id={positionName} className="blockContainer" key={positionName}>
        <div className="blockHeader">
          <h2>{i18n.t(`positions:${positionName}`)}</h2>
          <IconButton
            className={expandView ? 'expandView' : ''}
            onClick={this.handleExpandClick}
            aria-expanded={expandView}
            aria-label={i18n.t('schedule:showMore')}
          >
            <ExpandMoreIcon color="secondary" />
          </IconButton>
        </div>
        {this.displaySchedule()}
      </Paper>
    )
  }
}

AvailabilityPositionSchedule.defaultProps = {
  scheduleData: undefined,
}

AvailabilityPositionSchedule.propTypes = {
  includeWeekend: PropTypes.bool.isRequired,
  numberOfRequestedWeeks: PropTypes.number.isRequired,
  positionName: PropTypes.string.isRequired,
  scheduleData: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    profileImage: PropTypes.string,
    isFullTime: PropTypes.bool,
    isContractor: PropTypes.bool,
    isPOPreApproved: PropTypes.bool,
    primaryPositionId: PropTypes.number,
    abilityTier: PropTypes.number,
    bookingPriority: PropTypes.number,
    availabilitySchedule: PropTypes.arrayOf(PropTypes.shape({
      date: PropTypes.string,
      status: PropTypes.string,
    }))
  })),
  startOfSelectedWeek: PropTypes.instanceOf(Date).isRequired,
  hideUnavailables: PropTypes.bool.isRequired,
}

export default AvailabilityPositionSchedule;
